<template>
  <el-form class="dynamic-form"
           :inline="formConfig.inline"
           :rules="formConfig.rules"
           :model="value"
           :label-position="formConfig.labelPosition"
           :label-width="formConfig.labelWidth"
           :size='formConfig.size'
           :status-icon="formConfig.statusIcon"
           :disabled="formConfig.disabled"
           :ref="formConfig.ref"
  >
    <template v-for="(item) in formConfig.formItemList">
      <!--增加插槽位置-->
      <template v-if="item.slot === true">
        <slot v-if="item.key" :name="item.key"/>
        <slot v-else/>
      </template>
      <!--增加分割线-->
      <template v-else-if="item.split === true">
        <el-divider :key="item.key">
          <i :class="item.icon"/>
          <span style="font-size: 15px; font-weight: 700">{{item.text}}</span>
        </el-divider>
      </template>
      <template v-else>
        <dynamic-form-item
          v-if="show(item.isShow) === undefined ? true : show(item.isShow)"
          :key="item.key"
          :item="item"
          :value="value[item.key] || item.value"
          @input="handleInput($event, item.key)"
          @changeImage="changeImage($event, item.key)"
          :style="{'min-width':columnMinWidth}"
        />
      </template>
    </template>

  </el-form>
</template>

<script>
export default {
  props: {
    formConfig: {
      type: Object,
      required: true
    },
    value: {
      type: Object,
      required: true
    },
    columnMinWidth: {
      type: String
    }
  },
  methods: {
    handleInput (val, key) {
      // 这里element-ui没有上报event，直接就是value了
      this.$emit('input', {...this.value, [key]: val})
    },
    changeImage (val, key) {
      // 这里element-ui没有上报event，直接就是value了
      this.$emit('input', {...this.value, [key]: val})
    },
    setDefaultValue () {
      const formData = {...this.value}
      this.$emit('input', {...formData})
    }
  },
  mounted () {
    this.setDefaultValue()
    // console.info(this.formConfig.formItemList)
  },
  computed: {
    show () {
      return function (fun) {
        if (typeof fun === 'function') {
          return fun(this.value)
        } else {
          return fun !== false
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/dynamic-form/simple-form.vue